import { API_BASE } from "./api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Devuelve la URL absoluta de un archivo servido por el backend
export function fileUrl(url, download = false) {
  if (!url) return "";
  // Archivos subidos por el backend
  if (url.startsWith("/api/")) {
    const abs = `${BACKEND_URL}${url}`;
    return download ? `${abs}?download=1` : abs;
  }
  // URLs absolutas
  if (url.startsWith("http")) {
    return download ? `${url}?download=1` : url;
  }
  // Rutas locales (/images/...) servidas por el propio frontend
  return url;
}

// Sube un archivo en trozos (chunks) para evitar límites del proxy
export async function uploadFileChunked(file, onProgress) {
  const CHUNK = 4 * 1024 * 1024; // 4MB
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const token = localStorage.getItem("lc_token");
  let result = null;

  for (let i = 0; i < total; i++) {
    const start = i * CHUNK;
    const blob = file.slice(start, start + CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", i);
    fd.append("total_chunks", total);
    fd.append("filename", file.name);
    fd.append("chunk", blob);

    const res = await fetch(`${API_BASE}/uploads/chunk`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: fd,
    });
    if (!res.ok) throw new Error("Error al subir el archivo");
    result = await res.json();
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  return result; // { url, name, filename, type }
}
